import type { InputLabelProps, SxProps } from '@mui/material';
import { InputLabel as MuiInputLabel } from '@mui/material';
import React, { memo } from 'react';

const InputLabel: React.FC<{
  label?: React.ReactNode;
  required?: boolean;
  inputId?: string;
  style?: SxProps;
  inputLabelProps?: InputLabelProps;
}> = ({
  label = '',
  required = false,
  inputId = '',
  style,
  inputLabelProps,
}) => {
  if (!label) {
    return null;
  }

  return (
    <MuiInputLabel
      data-testid="input-label"
      htmlFor={inputId}
      required={required}
      sx={{
        ...style,
        whiteSpace: 'unset',
      }}
      {...inputLabelProps}
    >
      {label}
    </MuiInputLabel>
  );
};

export default memo(InputLabel);
